export enum UploadFileTypeEnum {
  'DICOM' = 'DICOM',
  'DXA' = 'DXA',
  'DICOMIZED_PDF' = 'DICOMIZED_PDF',
  'DICOMIZED_CSV' = 'DICOMIZED_CSV',
  'HRPQCT' = 'HRPQCT',
  // Quantitative CT (Mindways QCT workstation). Distinct from HRPQCT — different
  // modality, different workstation, different result set (D7-3530).
  'QCT' = 'QCT',
  'MEDIA' = 'MEDIA',
  'MISC' = 'MISC',
}

export enum UploadFileExtensionsEnum {
  'ZIP' = '.zip',
  'PDF' = '.pdf',
  'CSV' = '.csv',
}

export const uploadFileNamesMap: Record<UploadFileTypeEnum, string> = {
  [UploadFileTypeEnum.DICOM]: 'DICOM',
  [UploadFileTypeEnum.DXA]: 'DXA',
  [UploadFileTypeEnum.DICOMIZED_PDF]: 'PDF',
  [UploadFileTypeEnum.DICOMIZED_CSV]: 'CSV',
  [UploadFileTypeEnum.HRPQCT]: 'HRpQCT',
  [UploadFileTypeEnum.QCT]: 'QCT',
  [UploadFileTypeEnum.MEDIA]: 'Media',
  [UploadFileTypeEnum.MISC]: 'MISC',
};

export type CommonInventoryType = {
  id: string;
  name: string;
  dataType: UploadFileTypeEnum;
  inputDataType: UploadFileTypeEnum;
};
export type OrganizationType = CommonInventoryType & {
  address: string;
};
